export enum KanbanSpaces {
  workers = "Workers",
  // employers = "Employers",
}
